import { render, staticRenderFns } from "./Privacy2.vue?vue&type=template&id=8f79f0d8&scoped=true"
import script from "./Privacy2.vue?vue&type=script&lang=js"
export * from "./Privacy2.vue?vue&type=script&lang=js"
import style0 from "./Privacy2.vue?vue&type=style&index=0&id=8f79f0d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f79f0d8",
  null
  
)

export default component.exports